import TemplateImpressionController from './template.list.controller';

export default {
    template: require('./template.list.html'),
    controller: TemplateImpressionController
};
